import React from 'react';
import { List } from 'immutable';
import qs from 'qs';
import Results from './results';
import { event, eventDelayed } from '../utils/tracking';
import { extractUrlFilter } from '../utils/extractUrlFilter';
export default class ProductCategory extends React.Component {
  constructor(props) {
    super(props);

    const { site_id, limit_on, ...query} = qs.parse(props.location.search, {
      ignoreQueryPrefix: true
    });

    const url = props.match.url || props.location.pathname || props.history.location.pathname;
    // const query = (props.location && props.location.query) || {};

    const filters = props.filters || { tags: [] };
    const urlFilter = extractUrlFilter(props.match.url);
    if(urlFilter) {
      if(!filters.tags) {
        filters.tags = [];
      }

      filters.tags.push(urlFilter);
    }

    this.state = {
      sort: this.createSort({ '_raw.weight': -1 }),
      query,
      url,
      feed: props.feed,
      filtersUsed: false,
      siteId: site_id ? site_id : (props.feed ? '0' : '1'),
      limitOn: limit_on === '1' ? true : false,
      defaultFilters: {},
      filters: {
        ...filters,
        ...this.marshalQueryString(query)
      }
    };

    // this.state = this.mapPropsToState(props, {
    //   filters: {
    //     ...(this.props.filters || {})
    //   }
    // });
  }

  componentWillReceiveProps(props) {
    if (props.offers !== this.props.offers) {
      this.setState(this.mapPropsToState(props, this.state));
    }
  }

  marshalQueryString(query, { rules, parser } = {}) {
    if (!parser) {
      parser =
        typeof rules === 'object'
          ? query => {
              return Object.keys(query).reduce((acc, key) => {
                const value = query[key];
                acc[key] =
                  typeof rules[key] === 'function'
                    ? rules[key](value)
                    : JSON.parse(value);
                return acc;
              }, {});
            }
          : query => {
              return Object.keys(query).reduce((acc, key) => {
                acc[key] = JSON.parse(query[key]);
                return acc;
              }, {});
            };
    }

    try {
      return parser(query);
    } catch (err) {
      if (__DEV__) {
        console.log('error in marshalQueryString: ', err);
      }
      return {};
    }
  }

  mapPropsToState(props, state) {
    const { offers } = props;
    const { filters, sort = r => r } = state;

    const showcases = []; //offers && typeof offers.sortBy === 'function' ? offers.filter(o => o.getIn(['showcaseWeight'])).sortBy(o => o.get('showcaseWeight')).reverse() : [];

    return {
      ...state,
      offers: this.serialise(sort(offers)),
      filter: this.createFilter(filters),
      showcases
    };
  }

  createSort(args) {
    return offers => {
      if (offers && typeof offers.sort === 'function') {
        let sorted = offers;
        Object.keys(args).forEach(key => {
          const move = args[key] === -1 ? [-1, 1] : [1, -1];
          sorted = sorted.sort((a, b) => {
            const keys = key.split('.');
            const va = a.getIn(keys) || 0;
            const vb = b.getIn(keys) || 0;
            return va > vb ? move[0] : va < vb ? move[1] : 0;
          });
        });

        const lowPriority = sorted.reduce((acc, val) => {
          if (val.get('lowPriority')) {
            acc = acc.push(val);
          }
          return acc;
        }, new List());

        sorted = sorted.filter(v => !v.get('lowPriority'));
        sorted = sorted.concat(lowPriority);

        return sorted;
      }
      // if (offers && typeof offers.sortBy === 'function') {
      //   let sorted = offers;
      //   Object.keys(args).forEach(key => {
      //     sorted = sorted.sortBy(v => v.getIn(key.split('.')));
      //
      //     // reverse sorting order if -1 is specified in args for key
      //     // TODO when giving multiple sort criteria, this reverses the whole list anyway.
      //     // To solve this, make a function creator for a comparator func which is given to sortBy as the second arg
      //     if (args[key] == -1) {
      //       sorted = sorted.reverse();
      //     }
      //   });
      //
      //   const lowPriority = sorted.reduce((acc, val) => {
      //     if (val.get('lowPriority')) {
      //       acc = acc.push(val);
      //     }
      //     return acc;
      //   }, new List());
      //
      //   sorted = sorted.filter(v => !v.get('lowPriority'));
      //   sorted = sorted.concat(lowPriority);
      //
      //   return sorted;
      // }
      return offers;
    };
  }

  // pre-validate data, to ensure we only include valid offers
  serialise(offers) {
    const now = new Date();
    return offers
      .map(offer => {
        const subOffers = offer
          .get('subOffers')
          .filter(subOffer => new Date(subOffer.get('expire')) >= now);
        if (subOffers.size) {
          const original = offer;

          offer = offer.mergeDeep(subOffers.last());
          offer = offer.set('original', original);
        }

        return this.serialiseOffer(offer);
      })
      .filter(offer => {
        if (!offer) {
          return false;
        }

        const expire = offer.getIn(['_raw', 'expire']);
        if (expire) {
          return new Date(offer.get('expire')) >= now;
        }

        return true;
      });
  }

  // serialiseOffer(offer) {
  //   return fromJS({
  //     id: offer.get('_id'),

  //     provider: offer.get('provider'),
  //     logo: `${config.path.images}/${offer.get('imageUrl')}`,
  //     link: offer.get('trackingUrl'),
  //     orderText: 'Ansøg her',

  //     details: [ {
  //       value: '',
  //       unit: '',
  //       label: ''
  //     } ],

  //     price: {
  //       value: '-',
  //       label: ''
  //     },

  //     usps: [].filter(Boolean),

  //     remarks: {
  //       headline: '',
  //       text: ''
  //     },

  //     _raw: offer
  //   });
  // }

  // createFilter(filters) {
  //   return offers => offers.filter(offer => {
  //     return true;
  //   });
  // }

  updateFiltersUsed(filters) {
    const keys = Object.keys(this.state.defaultFilters);

    const search = this.props.location.search.match(/site_id=([0-9]+)/i);
    const limit = this.props.location.search.match(/limit_on=([0-9]+)/i);
    const url = this.props.match.url || this.props.location.pathname || this.props.history.location.pathname;
    const feed = this.props.feed;
    const siteId = search ? search[1] : (this.props.feed ? '0' : '1');
    const limitOn = limit ? limit[1] === '1' ? true : false : false;

    for (let idx = 0; idx < keys.length; idx++) {
      const key = keys[idx];
      
      if(['coverages', 'providers', 'tags'].includes(key)) {
        if(filters[key].length) {
          this.setState({ filtersUsed: true, url, feed, siteId, limitOn });
          return;
        }
      } else if(['download', 'upload'].includes(key)) {
        if(filters[key] !== this.state.defaultFilters[key]) {
          if((key === 'download' && filters[key] !== 0) || (key === 'upload' && filters[key] !== 0)) {
            this.setState({ filtersUsed: true, url, feed, siteId, limitOn });
            return;
          }
        }
      } else if(filters[key] !== this.state.defaultFilters[key]) {
        this.setState({ filtersUsed: true, url, feed, siteId, limitOn });
        return;
      }
    }

    this.setState({ filtersUsed: false, url, feed, siteId, limitOn });
  }

  updateFilters(filters) {
    this.setState({
      filter: this.createFilter(filters),
      filters
    });
  }

  sliderOnChange = ({ name, values }) => {
    const { filters } = this.state;
    filters[name] = Number(values[0]);

    this.updateFilters(filters);

    const basePath = `${this.props.category}/search/${name}`;
    eventDelayed(basePath, {
      path: `${basePath}/${filters[name]}`
    });
  };

  tagsOnChange = ev => {
    if (ev && ev.target) {
      const { value, checked } = ev.target;
      const { filters } = this.state;
      if (checked) {
        filters.tags.push(value);
      } else {
        const filteredTags = (filters.tags || []).map((v) => v.toLowerCase()).filter(v => v !== value.toLowerCase());
        filters.tags = filteredTags;
      }

      this.updateFilters(filters);
    }
  };

  checkboxOnChange = ev => {
    if (ev && ev.target) {
      const { name, type, value, checked } = ev.target;
      const { filters } = this.state;
      filters[name] = type === 'radio' ? value : checked;

      this.updateFilters(filters);

      event({
        path: `${this.props.category}/search/${name}/${filters[name]}`
      });
    }
  };

  createSearchDisplay(/*filters*/) {
    const arr = [];

    return arr;
  }

  renderResults(children, resetFilter, updateResults) {
    return (
      <Results
        results={this.state.offers}
        resetFilter={resetFilter}
        updateResults={updateResults}
        filter={this.state.filter}
        category={this.props.category}
        addressId={this.state.addressId}
        siteId={this.state.siteId}
        limitOn={this.state.limitOn}
        feed={this.state.feed}
        offerType={this.state.offerType}
        url={this.state.url}
        filtersUsed={this.state.filtersUsed}
        staticOffers={this.state.staticOffers}
        staticOffersSeparator={this.state.staticOffersSeparator}
      >
        {children}
      </Results>
    );
  }

  render() {
    return null;
  }
}
